import {
  Sparkles,
  Brush,
  Scissors,
  Droplets,
  Hand,
  PenTool,
  UtensilsCrossed,
  ShoppingBag,
  Tent,
  Dumbbell,
  Dog,
  Car,
} from "lucide-react";

export const categories = [
  { label: "Beauty", icon: <Sparkles size={28} className="text-redlight" /> },
  { label: "Nails", icon: <Brush size={28} className="text-redlight" /> },
  { label: "Barbers", icon: <Scissors size={28} className="text-redlight" /> },
  {
    label: "Spa & sauna",
    icon: <Droplets size={28} className="text-redlight" />,
  },
  { label: "Massages", icon: <Hand size={28} className="text-redlight" /> },
  { label: "Tattoo", icon: <PenTool size={28} className="text-redlight" /> },
  {
    label: "Restaurants",
    icon: <UtensilsCrossed size={28} className="text-redlight" />,
    needHours: true,
  },
  {
    label: "Take a way",
    icon: <ShoppingBag size={28} className="text-redlight" />,
    needHours: true,
  },
  {
    label: "Night Market",
    icon: <Tent size={28} className="text-redlight" />,
    needHours: true,
  },
  { label: "Gym", icon: <Dumbbell size={28} className="text-redlight" /> },
  { label: "Pet care", icon: <Dog size={28} className="text-redlight" /> },
  { label: "Car wash", icon: <Car size={28} className="text-redlight" /> },
];
